import { apiClient } from '@/infrastructure/api'
import {
  InvoicingApi,
  DashboardAnalyticsApiReturnRateTableRequest
} from '@itsrever/rever-api'
import { OrderBy } from '@/utils'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

export const OrderingValues = {
  ReturnRate: 'RETURN_RATE',
  Sold: 'SOLD',
  Returned: 'RETURNED'
}

const invoicingApi = new InvoicingApi(undefined, undefined, apiClient)

const returnRateTableArgs: DashboardAnalyticsApiReturnRateTableRequest = {
  ecommerceId: '',
  orderingDirection: OrderBy.Desc,
  orderingValue: 'SOLD',
  pageNumber: 1
}

const initialState = {
  returnRateTableArgs
}

export async function getInvoicingInfo(ecommerceId: string) {
  const result = await invoicingApi.getEcommerceInvoicingInfo({ ecommerceId })
  return result.data
}

const analyticsApiSlice = createSlice({
  name: 'lineItemsApi',
  initialState,
  reducers: {
    setReturnRateTableArgs(
      state,
      action: PayloadAction<DashboardAnalyticsApiReturnRateTableRequest>
    ) {
      state.returnRateTableArgs = {
        ...state.returnRateTableArgs,
        ...action.payload
      }
    }
  }
})

export const { setReturnRateTableArgs } = analyticsApiSlice.actions
export default analyticsApiSlice.reducer
